import { useEffect, useState } from "react";
import { InputAdornment, TextField, Autocomplete } from '@mui/material';
import { getAgents } from "../../Services/Agent";
import { useTranslation } from "react-i18next";

const AgentDetails: React.FunctionComponent<{ agent: any, OnChangeAgent: any }> = (props) => {

    const [agentValue, setAgentValue] = useState<any>(props.agent.agentInfo?.name);
    const [Agents, setAgents] = useState<any>([]);
    const { t } = useTranslation();

    // Agent 

    useEffect(() => {
        getAgents("").then((data) => {
            setAgents(data)
        }).catch((error: any) => {
            console.log("error")
        })
    }, [])

    // Agent 

    const handleSearchAgent = (event: any) => {
        console.log("agent", event.target.value)
        getAgents(event.target.value).then((data) => {
            setAgents(data)
        }).catch((error: any) => {
            console.log("error")
        })
    }

    const handleSelectChangeAgent = (newValue: any) => {
        props.OnChangeAgent(newValue)
    }

    return (

        <div className="card border-16 mb-4">
            <div className="padd-30">
                <div className="row ">
                    <div className="col-md-8">
                        <div className="agent-header">
                            <div className="col-md-4 mb-4">
                                <h1 className="title-24 title-20-mb color-black marg-right-16">{t("listingCreation.agentDetails")}</h1>
                            </div>
                            <div className="col-md-8 mb-4">
                                <Autocomplete
                                    freeSolo
                                    value={props.agent.agentInfo?.name || ""}
                                    onChange={(event: any, newValue: any) => {
                                        if (newValue === null) {
                                            setAgentValue("");
                                            return;
                                        }
                                        const selectedAgent = Agents.find((agent: any) =>
                                            agent.fullName === newValue?.fullName
                                        );
                                        handleSelectChangeAgent(selectedAgent ? selectedAgent : "");
                                    }}
                                    className="input-location back-F1F5F9 color-06 w-100"
                                    options={Agents}
                                    isOptionEqualToValue={(option, value) => option === value}
                                    getOptionLabel={(option) => typeof option === "string" ? option : option.fullName || ""}
                                    noOptionsText={Agents.length === 0 ? "No agents found" : ""}
                                    renderOption={(props: any, option: any) => (
                                        <li {...props}>
                                            <img
                                                src={option.image}
                                                alt={option.fullName}
                                                style={{
                                                    width: 30,
                                                    height: 30,
                                                    borderRadius: "50%",
                                                    marginRight: 10,
                                                    objectFit: "cover"
                                                }}
                                            />
                                            {option.fullName}
                                        </li>
                                    )}
                                    renderInput={(params: any) => (
                                        <TextField
                                            {...params}
                                            placeholder={t("propertyDetails.searchby")}
                                            InputProps={{
                                                ...params.InputProps,
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M15.8482 15.2164L11.7172 11.1515C12.799 9.97622 13.4637 8.42186 13.4637 6.71146C13.4632 3.05259 10.4494 0.0869141 6.73158 0.0869141C3.0137 0.0869141 0 3.05259 0 6.71146C0 10.3703 3.0137 13.336 6.73158 13.336C8.33795 13.336 9.81129 12.7804 10.9686 11.8567L15.1155 15.9376C15.3176 16.1367 15.6457 16.1367 15.8477 15.9376C16.0502 15.7386 16.0502 15.4155 15.8482 15.2164ZM6.73158 12.3168C3.58585 12.3168 1.03575 9.8072 1.03575 6.71146C1.03575 3.61572 3.58585 1.10614 6.73158 1.10614C9.87733 1.10614 12.4274 3.61572 12.4274 6.71146C12.4274 9.8072 9.87733 12.3168 6.73158 12.3168Z" fill="black" />
                                                        </svg>
                                                    </InputAdornment>
                                                )
                                            }}
                                            onChange={handleSearchAgent}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="border-16 mb-4 mt-2"></div>
                    <div className="col-md-6 order-11">
                        <div className="info-line mb-3">
                            <div className="col-4">
                                <label className="form-label-1">{t("report.phone")}:</label>
                            </div>
                            <div className="col-1">
                                <input type="text" className="border-0-2 border-8 back-FFFFFF w-100 height-48 padd-15-30 text-center bold-700 para-14 color-black disabled" value={props.agent.agentInfo?.phone || ""} readOnly />
                            </div>
                        </div>
                        <div className="info-line mb-3">
                            <div className="col-4">
                                <label className="form-label-1">{t("qrCode.email")}:</label>
                            </div>
                            <div className="col-1">
                                <input type="text" className="border-0-2 border-8 back-FFFFFF w-100 height-48 padd-15-30 text-center bold-700 para-14 color-black disabled" value={props.agent.agentInfo?.email || ""} readOnly />
                            </div>
                        </div>
                        <div className="info-line mb-3">
                            <div className="col-4">
                                <label className="form-label-1">{t("listingCreation.languages")}:</label>
                            </div>
                            <div className="col-1">
                                <p className="bold-600 para-14 color-black text-center">{props.agent.agentInfo && props.agent.agentInfo?.languages && props.agent.agentInfo?.languages.map((s: string) => s.charAt(0).toUpperCase() + s.slice(1)).join(', ')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 order-00 d-flex justify-content-end align-items-center">
                        <div className="agent-profile">
                            <img
                                src={props.agent.agentInfo?.photoUrl ? props.agent.agentInfo?.photoUrl : "https://cdn-icons-png.freepik.com/256/3135/3135715.png?semt=ais_hybrid"}
                                alt="Agent"
                                className="agent-img mb-3"
                            />
                            <p className="title-20 bold-700" >{props.agent.agentInfo?.name}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}


export default AgentDetails;